<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="epigraph_1"></a><p class="ep"><em>The risk it takes to remain tight inside the bud<br/>is more painful than the risk it takes to blossom.</em></p><p class="eps">—A<span class="small">NAïS</span> N<span class="small">IN</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Conversationsw_epig_1.vue?277be305